import {
	requests
}from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/RePriceCalculationType/create', params),
	update        : (params) => requests.post('/RePriceCalculationType/update', params),
	delete        : (params) => requests.getWithParams('/RePriceCalculationType/delete', params),
	restore       : (params) => requests.getWithParams('/RePriceCalculationType/restore', params),
	getPaged      : (params) => requests.getWithParams('/RePriceCalculationType/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/RePriceCalculationType/getPagedAudit', params),
	getPagedAll   : (params) => requests.getWithParams('/RePriceCalculationType/getPagedAll', params),
	getList       : (params) => requests.getWithParams('/RePriceCalculationType/getList', params)
}